import { useScrollReveal } from '@/hooks/useScrollReveal';

const features = [
  {
    icon: 'ri-calendar-schedule-line',
    title: 'Capacity Calendar & Booking',
    desc: 'Set availability by date, manage bookings, and accept or decline requests — all from your dashboard. See your pipeline weeks ahead.',
    color: 'bg-secondary-100 text-secondary-600',
  },
  {
    icon: 'ri-temp-cold-line',
    title: 'IoT Temperature Monitoring',
    desc: 'Real-time temperature sensors with automatic exception alerts. If a freezer drifts outside spec, you know before it becomes a problem.',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-barcode-box-line',
    title: 'Inventory & Batch Traceability',
    desc: 'Every batch that enters your facility gets a digital ID. Track what\'s stored, where it came from, and where it\'s going — full chain of custody.',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-bank-card-line',
    title: 'Settlement & Payout Dashboard',
    desc: 'Weekly automated settlements with full breakdowns — freezing fees, storage fees, bonuses. No chasing payments, no reconciliation headaches.',
    color: 'bg-secondary-100 text-secondary-700',
  },
];

export default function FeaturesSection() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold text-secondary-600 uppercase tracking-widest mb-4">
            Platform Tools
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-700 mb-4">
            Built for Warehouse Operators
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto">
            Everything you need to run your facility more efficiently — and earn more from every square foot of freezing capacity.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
          {features.map((feat) => (
            <div key={feat.title} className="group flex items-start gap-5 p-6 rounded-xl bg-card-50 shadow-sm border border-card-200 hover:shadow-md transition-all duration-300 card-animate">
              <div className={`w-14 h-14 flex-shrink-0 flex items-center justify-center rounded-xl ${feat.color} animate-icon-float icon-hover-pop`}>
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <div>
                <h3 className="font-heading font-bold text-primary-700 text-base mb-2">{feat.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}